var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddCartRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.75,
    fill: "white",
    stroke: "#D94E49",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3773 12.2898H18.5474V11.6054C18.5474 9.61819 16.9307 8 14.9419 8C12.9532 8 11.3365 9.61669 11.3365 11.6054V12.2898H8.50653C8.22712 12.2898 8 12.5169 8 12.7963V20.2821C8 21.7808 9.21925 23 10.7179 23H19.1645C20.6631 23 21.8824 21.7808 21.8824 20.2821V12.7963C21.8824 12.5169 21.6553 12.2898 21.3758 12.2898H21.3773ZM12.3495 12.2898V11.6054C12.3495 10.1755 13.512 9.01305 14.9419 9.01305C16.3719 9.01305 17.5343 10.1755 17.5343 11.6054V12.2898H12.351H12.3495Z",
    fill: "#D94E49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddCartRed);
export default __webpack_public_path__ + "static/media/icon_add_cart_red.aa9df9856f83dd3a3b808d7e76ee8e0b.svg";
export { ForwardRef as ReactComponent };